import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import classes from "./CommentBox.scss";
import { getCommentsOfNodeFromCache } from "modules/CommonGraphqlHelpers";
import { getCommentOfNodeQuery } from "modules/CommonQuery";
import CommentPane from "./CommentPane";
import { updateLocalComment, markCommentRead } from "modules/Services";
import {
  createComment,
  updateComment,
  deleteComment,
} from "AppComponents/CommentBoxV2/modules/CommentThunks";
import withPusherBind from "UIComponents/PusherConsumerHoc";
import { getUnitPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import { getUnitPlanFieldResponseFilter } from "UnitPlans/modules/Utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import ACLStore from "lib/aclStore";
import PropTypes from "prop-types";
import { getUnitPlanCentralRepoInputAndFilters } from "routes/routes/Teacher/routes/Courses/modules/utils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";

class CommentBox extends React.Component {
  componentDidMount = () => {
    this.props.updateLocalComment({
      id: this.props.nodeId,
      commentData: { label: "", attachments: [] },
    });
  };
  updateLocalComment = params => {
    const { createCommentData, nodeId } = this.props;
    const commentData = _.get(createCommentData, [nodeId], {});
    const updatedCommentData = {
      ...commentData,
      ...params,
    };
    this.props.updateLocalComment({
      id: nodeId,
      commentData: updatedCommentData,
    });
  };

  markCommentRead = () => {
    const {
      nodeId,
      type,
      parentType,
      commentsKey,
      isCommunity,
      isCommentV2 = false, //Projects uses commentV2 for all their field comments instead of normal comments
      updateReadCount, // Used to update the read count manually
    } = this.props;
    this.props.markCommentRead({
      nodeId,
      type,
      parentType,
      commentsKey,
      isCommunity,
      isCommentV2,
      updateReadCount,
    });
  };

  createComment = async ({
    parentMessageId,
    message,
    itemType,
    replyItemId,
    attachments,
    label,
  } = {}) => {
    const {
      nodeId,
      type,
      parentType,
      unitPlanId,
      collaborators,
      commentsKey,
      getCommentOfNode,
    } = this.props;
    const entityName = _.get(getCommentOfNode, "node.title.value");
    return await this.props.createComment({
      nodeId,
      type,
      parentType,
      collaborators,
      commentsKey,
      parentMessageId,
      message,
      itemType,
      entityName,
      replyItemId,
      attachments,
      newCommentLabel: label,
    });
  };

  updateComment = async ({ comment_id, comment, attachments }) => {
    const { collaborators, comments, commentsKey } = this.props;
    const commentDetails = _.get(
      _.find(comments, ({ node: { id } }) => {
        return comment_id == id;
      }),
      "node",
      {}
    );

    await this.props.updateComment({
      comment_id,
      comment,
      collaborators,
      commentDetails,
      attachments,
      commentsKey,
    });
  };

  deleteComment = ({ comment_id, itemType, parentMessageId }) => {
    const {
      nodeId,
      type,
      parentType,
      commentsKey,
      getCommentOfNode,
    } = this.props;
    const entityName = _.get(getCommentOfNode, "node.title.value");
    this.props.deleteComment({
      nodeId,
      comment_id,
      type,
      parentType,
      commentsKey,
      itemType,
      parentMessageId,
      entityName,
    });
  };

  updateCommentPaneRef = ref => {
    this.commentPaneRef = ref;
  };

  render() {
    const {
      comments,
      createCommentData,
      onClose,
      userInfo,
      totalCounts,
      isData,
      isLoading,
      hasNextPage,
      headerStyle,
      feedStyle,
      commentBoxContainerStyle,
      commentContainerStyle,
      fetchMoreFeed,
      getCommentOfNode,
      nodeId,
      renderHeaderComponent,
      collaborators,
      disableTagging,
      sendOnEnter,
      commentItemContainerStyle,
      showProfileAvatar,
      scrollable,
      hideEmptyView,
      isNodeDeleted,
      setToastMsg,
      deleteOtherComment,
      canCreateComment,
      parentType,
      commentPaneContainerStyle,
      seeMoreContainerStyle,
      allowReply,
      theme,
      isCommunity,
      canCreateAudioComment,
      commentItemStyle,
      nagivateToProfile,
      scrollToPosition,
      sendButtonText,
      commentBoxInnerWrapper,
      bottomButtonsContainer,
      sendButtonStyle,
      unveilMaxHeight,
      isPublicAccess,
      isCurrentAcademicYearSelected,
      isRightPaneChat,
      testId,
      mode, // disabling liking post and comment actions in view mode
    } = this.props;

    return (
      <div className={classes.container} style={commentContainerStyle}>
        <CommentPane
          ref={this.updateCommentPaneRef}
          deleteOtherComment={deleteOtherComment}
          markCommentRead={this.markCommentRead}
          renderHeaderComponent={renderHeaderComponent}
          headerStyle={headerStyle}
          feedStyle={feedStyle}
          commentBoxContainerStyle={commentBoxContainerStyle}
          bottomButtonsContainer={bottomButtonsContainer}
          comments={comments}
          createCommentData={createCommentData[nodeId] || {}}
          onClose={onClose}
          userInfo={userInfo}
          fetchMoreFeed={fetchMoreFeed}
          totalCounts={totalCounts}
          isData={isData}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
          scrollable={scrollable}
          getCommentData={getCommentOfNode}
          updateLocalComment={this.updateLocalComment}
          createComment={this.createComment}
          updateComment={this.updateComment}
          deleteComment={this.deleteComment}
          collaborators={collaborators}
          disableTagging={disableTagging}
          sendOnEnter={sendOnEnter}
          commentItemContainerStyle={commentItemContainerStyle}
          showProfileAvatar={showProfileAvatar}
          hideEmptyView={hideEmptyView}
          isNodeDeleted={isNodeDeleted}
          setToastMsg={setToastMsg}
          canCreateComment={canCreateComment}
          nodeId={nodeId}
          parentType={parentType}
          commentPaneContainerStyle={commentPaneContainerStyle}
          seeMoreContainerStyle={seeMoreContainerStyle}
          allowReply={allowReply}
          theme={theme}
          isCommunity={isCommunity}
          canCreateAudioComment={canCreateAudioComment}
          commentItemStyle={commentItemStyle}
          nagivateToProfile={nagivateToProfile}
          scrollToPosition={scrollToPosition}
          sendButtonText={sendButtonText}
          commentBoxInnerWrapper={commentBoxInnerWrapper}
          sendButtonStyle={sendButtonStyle}
          unveilMaxHeight={unveilMaxHeight}
          isPublicAccess={isPublicAccess}
          isCurrentAcademicYearSelected={isCurrentAcademicYearSelected}
          isRightPaneChat={isRightPaneChat}
          mode={mode}
          testId={testId}
        />
      </div>
    );
  }
}

const mapActionCreators = {
  updateLocalComment,
  createComment,
  deleteComment,
  updateComment,
  markCommentRead,
  setToastMsg,
};

const mapStateToProps = (state, ownProps) => {
  const { commentsKey } = ownProps;
  const unitPlanId =
    _.get(state.planner, "unitPlanData.unitPlanId", "") || ownProps.unitPlanId;

  const userInfo = getUserInfo();
  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course",
    ""
  );

  const academicYearId = getSelectedAcademicYearId(state);

  const canCreateAudioComment =
    _.get(ownProps, "canCreateAudioComment", false) &&
    ACLStore.can("Common:AddAudioComment");

  const collaborators =
    unitPlanId || ownProps.collaborators
      ? getCollaborators({
          collaboratorValue: ownProps.collaborators,
          unitPlanId,
          userInfo,
          selectedCourseId,
          academicYearId,
        })
      : [];
  const isCommunity = state.login.activeTab == "community";
  const isPublicAccess = false;

  return {
    unitPlanId,
    collaborators,
    createCommentData: state.app_services.createComment,
    userInfo,
    isCommunity,
    commentsKey: getCommentsKey({ commentsKey, isCommunity }),
    canCreateAudioComment,
    isPublicAccess,
  };
};

const getCommentsKey = ({ commentsKey, isCommunity }) => {
  if (!_.isEmpty(commentsKey)) {
    return commentsKey;
  }
  if (isCommunity) {
    return "communityComments";
  }
  return "comments";
};

const getCollaborators = ({
  collaboratorValue,
  unitPlanId,
  userInfo,
  selectedCourseId,
  academicYearId,
}) => {
  const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
    organizationId: _.get(userInfo, "org_id", ""),
    courseId: selectedCourseId,
    academicYearId,
  });

  const responseFilter = getUnitPlanFieldResponseFilter();
  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  const unitPlanData = unitPlanId
    ? getUnitPlanDetailsFromCache({
        unitPlanId,
        centralRepoInput,
        responseFilter,
        collaboratorsFilter,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
      })
    : {};

  const allCollaborators = collaboratorValue
    ? collaboratorValue
    : _.cloneDeep(_.get(unitPlanData, "collaborators", []));
  const collaborators = _.filter(
    _.map(_.get(allCollaborators, "edges"), item => {
      return item.node;
    }),
    item => item.id != userInfo.id
  );

  collaborators.push({
    id: "all",
    firstName: "common:all",
    lastName: "",
    profileImage: "",
    iconType: "group",
    color: "neutral",
  });

  return collaborators;
};

const ComposedCommentBox = compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getCommentOfNodeQuery, {
    name: "getCommentOfNode",
    options: ({ nodeId, type, firstCount, isCommunity }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: nodeId,
        type: type,
        first: firstCount,
        isCommunity,
      },
    }),
    props({
      getCommentOfNode,
      ownProps: {
        nodeId,
        type,
        firstCount,
        parentType,
        markCommentRead,
        isCommunity,
        commentsKey,
      },
    }) {
      const nodeFields = getCommentsOfNodeFromCache({
        nodeId: nodeId,
        type,
        isCommunity,
      });
      const comments = _.get(nodeFields, commentsKey, []);
      const isNodeDeleted = _.get(nodeFields, "isDeleted", false);
      return {
        getCommentOfNode,
        onPusherEventTriggered: params => {
          if (nodeId == params.parentId && parentType == params.parentType) {
            getCommentOfNode.refetch();
            markCommentRead({
              nodeId,
              type,
              parentType,
              isCommunity,
              commentsKey,
            });
          }
        },
        isNodeDeleted,
        totalCounts: _.get(comments, "totalCount", 0),
        comments: [..._.get(comments, "edges", [])].reverse(),
        hasNextPage: _.get(comments, "pageInfo.hasNextPage", false),
        isData: !_.isEmpty(nodeFields),
        isLoading:
          getCommentOfNode["networkStatus"] == 1 ||
          getCommentOfNode["networkStatus"] == 2,
        fetchMoreFeed: () => {
          const endCursor = _.get(comments, "pageInfo.endCursor", null);

          return getCommentOfNode.fetchMore({
            variables: {
              after: endCursor,
              id: nodeId,
              type,
              first: firstCount,
              isCommunity,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const previousField = previousResult.node;
              const newField = fetchMoreResult.node;

              return {
                ...previousResult,
                node: {
                  ...previousField,
                  [commentsKey]: {
                    ...previousField[commentsKey],
                    pageInfo: newField[commentsKey].pageInfo,
                    edges: [
                      ...previousField[commentsKey].edges,
                      ...newField[commentsKey].edges,
                    ],
                  },
                },
              };
            },
          });
        },
      };
    },
  }),
  withPusherBind(["nodeCommentFeedUpdate"])
)(CommentBox);

ComposedCommentBox.defaultProps = {
  deleteOtherComment: false,
  canCreateAudioComment: true,
  unveilMaxHeight: 104,
  mode: "edit",
  testId: "appComponents",
};

ComposedCommentBox.propTypes = {
  deleteOtherComment: PropTypes.bool,
  testId: PropTypes.string,
};

export default ComposedCommentBox;
